/* unplugin-vue-components disabled */import { render } from "./hotMap.vue?vue&type=template&id=162ef195"
import script from "./hotMap.vue?vue&type=script&lang=js"
export * from "./hotMap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__